import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api"



import Header from "./content/header"

class EditMatriculaAdm extends Component {

state= {
  matricula:[],
  idmatricula:null,
  precoinscricao:null,
  status:null,
  error:null,
  paid:null,
  success:null,
  aluno:null,
  cursos:[],
  idcurso:"",
  primeirafaturagerada:"",
  datacobranca:"",
  mensalidade:"",
  mensalidadedesconto:"",
  qtdparcelas:"",
  codturma:"",
  observacao:null,
  isead:0,
  datapagamento:null
}

    async componentDidMount(){

      this.loadcursos();

      const response = await api.post("/admin/matricula/id", { idmatricula:this.props.match.params.idmatricula });
      this.setState({
        matricula:response.data,
        idmatricula:this.props.match.params.idmatricula,
        precoinscricao:response.data.price,
        status:response.data.status,
        paid:response.data.paid,
        aluno:response.data.user.dados_users.nomecompleto,
        idcurso:response.data.idcurso,
        qtdparcelas:response.data.qtdparcelas,

        primeirafaturagerada:response.data.primeirafaturagerada,
        datacobranca:response.data.datacobranca,
        mensalidade:response.data.mensalidade,
        mensalidadedesconto:response.data.mensalidadedesconto,
        codturma:response.data.codturma,
        observacao:response.data.observacao,
        isead:response.data.isead,
        datapagamento:response.data.datapagamento
  

      })
    
    }




    async loadcursos () {
      const response = await api.get("/cursosadm");
      this.setState({ cursos: response.data });
    }
 



  editmatricula = async e => {
    e.preventDefault();
    let { idmatricula, precoinscricao, status, paid, idcurso, codturma,isead,
      mensalidade,mensalidadedesconto, datacobranca,qtdparcelas,observacao,datapagamento } = this.state;
      if (!idmatricula || !precoinscricao || !idcurso || !mensalidade || !mensalidadedesconto || !datacobranca || !qtdparcelas || !codturma) {
          this.setState({ error: "Preencha os dados antes de editar!",
        success:null });
          
      } else {
      let { idmatricula, precoinscricao, status, paid, idcurso,isead } = this.state;
      const response = await api.post("/admin/matricula/edit", {
        observacao,
        codturma,
        qtdparcelas,
        mensalidade,
        mensalidadedesconto,
         datacobranca, idcurso, idmatricula, 
         precoinscricao, status, paid,isead,
        datapagamento });

        if(response.data.id){
          this.setState({ success: "Matricula Atualizada!" , error:null,
        nome:null });
        }

      }
  }


  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-4 p-4">     

        <h4>Editar Matricula</h4>     
        <form onSubmit={this.editmatricula}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

                <div class="form-group">
                    <label for="exampleFormControlInput1">Aluno</label>
                    <input type="text" class="form-control" value={this.state.aluno} disabled />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Curso</label>
                    <select class="browser-default custom-select"  onChange={e => this.setState({ idcurso: e.target.value })} >

                    <option>Selecione um valor</option>

                    {this.state.cursos.map(el => (
                      
                      <option value={el.id} selected={this.state.idcurso==el.id}>{el.nome} | Unidade ID #{el.idunidade}  </option>
                      
                    ))}
                    </select>
                </div>

                <div class="form-group">
                  <label for="exampleFormControlInput1">Código Turma</label>
                  <input type="text" class="form-control" defaultValue={this.state.codturma} onChange={e => this.setState({ codturma: e.target.value })} />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Inscrição</label>
                    <input type="text" class="form-control" defaultValue={this.state.precoinscricao} onChange={e => this.setState({ precoinscricao: e.target.value })} />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Mensalidade </label>
                    <input type="text" class="form-control" defaultValue={this.state.mensalidade} onChange={e => this.setState({ mensalidade: e.target.value })} />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Mensalidade com Desconto</label>
                    <input type="text" class="form-control" defaultValue={this.state.mensalidadedesconto} onChange={e => this.setState({ mensalidadedesconto: e.target.value })} />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Quantidade Parcelas </label>
                    <input type="text" class="form-control" defaultValue={this.state.qtdparcelas} onChange={e => this.setState({ qtdparcelas: e.target.value })} />
                </div>

                <div class="form-group">
                  <label for="exampleFormControlInput1">Cobrar 1º a partir de</label>
                  <input type="date" class="form-control" defaultValue={this.state.datacobranca} onChange={e => this.setState({ datacobranca: e.target.value })} />
                </div>

                <div class="form-group">
                  <label for="exampleFormControlInput1">Data do Pagamento da Matricula</label>
                  <input type="date" class="form-control" defaultValue={this.state.datapagamento} onChange={e => this.setState({ datapagamento: e.target.value })} />
                </div>
                


                <div class="form-group">
                    <label for="exampleFormControlInput1">Pagamento</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ paid: e.target.value })}>
                      <option value="1" selected={this.state.paid==true}>Efetuado</option>
                      <option value="0" selected={this.state.paid==false}>Não Efetuado</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Modalidade</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ isead: e.target.value })}>
                      <option value="1" selected={this.state.isead==1}>EAD</option>
                      <option value="0" selected={this.state.isead==0}>Presencial</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Status</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ status: e.target.value })} >
                      <option value="0" selected={this.state.status==0}>Pendente</option>
                      <option value="1" selected={this.state.status==1}>Ativa</option>
                      <option value="2" selected={this.state.status==2}>Cancelada</option>
                      <option value="4" selected={this.state.status==4}>Concluída</option>
                      <option value="5" selected={this.state.status==5}>Concluída com Pendência</option>
                      <option value="6" selected={this.state.status==6}>Formado</option>
                      <option value="7" selected={this.state.status==7}>Ativa Totalmente Paga</option>
                    </select>
                </div>
                <div class="form-group">
                  <label for="exampleFormControlInput1">Observação</label>
                  <textarea rows="5" cols="70" onChange={e => this.setState({ observacao: e.target.value })} 
               class="form-control" value={this.state.observacao}
                >
                  
                  
                </textarea>
                </div>


                <div class="form-group">
                <button class="btn btn-primary mb-2">Alterar Dados</button>

                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(EditMatriculaAdm);


// WEBPACK FOOTER //
// ./src/pages/Admin/editmatricula.js